<template>
    <div class="recommend-list">
        <div
            v-for="item, index in list"
            :key="index"
            v-visually="{
                serverId: 19022,
                area: 'answer',
                ext: {
                    qid: item.qid,
                },
            }"
            class="recommend-item"
        >
            <div class="title">
                <span
                    v-if="item.hot_level >= 1 && item.hot_level < 3"
                    class="icon"
                    :class="'icon_' + item.hot_level"
                ></span>{{ item.title }}
            </div>
            <div class="info">
                <div class="date">
                    {{ formatData(item.update_time) }}
                </div>
                <div

                    class="domain"
                >
                    <div
                        v-for="domain, domainIndex in handleDomain(item.domain_v3)"
                        :key="domainIndex"
                        class="domain-item"
                    >{{ domain }}</div>
                </div>
            </div>
            <div class="btn" @click="answer(item)">
                AI抢答
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';

// 推荐问题
export default {
    name: 'recommendList',
    props: {
        list: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        formatData(date) {
            return date ? dayjs.unix(date).format('YYYY.MM.DD') : '';
        },
        handleDomain(str) {
            return str && str.split(',') || [];
        },
        answer(data) {
            // 跳转编辑页面
            this.$emit('answer', {qaInfo: data});
            this.$wywLog.send({
                serverId: 19022,
                area: 'answer',
                action: 'click',
                qid: data.qid
            });
        }
    }
};
</script>

<style lang='less' scoped>
.recommend-list {
    .recommend-item {
        padding: 24px 0;
        position: relative;

        &:not(:first-child) {
            border-top: 1px solid #e9ecf3;
        }

        .title {
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            margin-bottom: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: calc(100% - 150px);

            .icon {
                display: inline-block;
                height: 16px;
                width: 16px;
                vertical-align: top;

                &.icon_1 {
                    background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/hot_1.png) no-repeat center / 100% 100%;
                }

                &.icon_2 {
                    background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/hot_2.png) no-repeat center / 100% 100%;
                }

                &.icon_3 {
                    background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/hot_3.png) no-repeat center / 100% 100%;
                }
            }
        }

        .info {
            display: flex;
            align-items: center;

            .date {
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 14px;
                text-align: left;
                color: #848691;
                padding-left: 18px;
                position: relative;

                &::before {
                    content: "";
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    left: 0;
                    top: 0;
                    background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/clock.png") center / 100% 100%;
                }
            }

            .domain {
                display: flex;
                color: #737d99;
                font-family: PingFang SC;
                font-size: 12px;
                font-weight: 500;

                .domain-item {
                    line-height: 10.5px;
                    text-align: center;
                    height: 18px;
                    padding: 3px 4px;
                    border: 1px solid #737d9966;
                    border-radius: 4px;
                    margin-left: 10px;
                }
            }
        }

        .btn {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border: 1px solid #05f;
            height: 40px;
            width: 95px;
            border-radius: 5px;
            color: #05f;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
        }
    }
}
</style>
